import numeral from 'numeral'

function formatNumber(number, decimals = false) {
  let value = ''

  if (decimals && (number || number === 0)) {
    value = numeral(number).format('0,0.00')
  } else if (!decimals && (number || number === 0)) {
    value = numeral(number).format('0,0')
  }

  return value
}

export { formatNumber }
